export function productReducer(state = "",{
    type,
    payload
}){
    
    
    switch(type){
        case "NEW_PRODUCT":
        case "UPDATE_PRODUCT":
            return {
                ...state,
                [payload.id]: payload
            }
        case "GET_PRODS":
            return payload;
        case "DELETE_PRODUCT":
            const { [payload.id]: deleted, ...newState } = state;
            return newState;
        case "SET_MAIN_PHOTO":
            return {
                ...state,
                [payload.prodID]: {
                    ...state[payload.prodID],
                    src: [],
                    mainPhoto: [payload.URI]
                }
            }

        case "SET_ALL_PHOTOS":
            const updatedState = { ...state };
            payload.forEach(photo => {
                updatedState[photo.key] = {
                    ...updatedState[photo.key],
                    src: [],
                    mainPhoto: photo.value
                };
            });
            return updatedState;
        case "SET_PHOTOS":
            const existingProduct = state[payload.prodID];
            const existingSrc = existingProduct && existingProduct.src ? [...existingProduct.src] : [];
            existingSrc.push(payload.URI);
            
            return {
                ...state,
                [payload.prodID]: {
                    ...existingProduct,
                    src: existingSrc
                }
            }
        default:
            return state;
    }
    
}
